






















import { listFactory } from '@/main/pages';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

const CHECK_IN_ROW_KEY = '11';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		VozidloSelect: Vozidlo.components.Select,
	},
	data() {
		return {
			rowKey: CHECK_IN_ROW_KEY,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${listMutations.PRACOVNIK_FILTER_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${listMutations.VOZIDLO_FILTER_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { id: event.data.CHECKIN_ID });
		},
		viewClick(event: any) {
			openEdit(NAME, PageMode.VIEW, { id: event.data.CHECKIN_ID });
		},
	},
});
